import {gql} from 'apollo-angular';

export const GET_ROOKIE_PROFESSION_PREVIEWS = gql`
  query GetRookieProfessionPreviews {
    rookieProfessionPreviews {
      id
      name
      image {id}
      positionType
      associatedProfessions {id}
      companyProfile {id}
      addresses {id}
      interestFields
    }
  }
`;
